module.exports = __webpack_public_path__ + "img/tailwind.cc9da5fe.png";